module.exports = __webpack_public_path__ + "img/3.2.TN.42e0490d.png";